module.exports = __webpack_public_path__ + "static/media/icon-arrow.b9bb5146.svg";